import { put, takeLatest } from "redux-saga/effects";
import { 
    getSeatsSuccess, 
    getSeatByIdSuccess,
    getSeatsByShowIdSuccess,
    getAvailableSeatsSuccess,
    updateSeatStatusSuccess,
    bookSeatSuccess,
    getSeatsFailed,
    getSeatByIdFailed,
    getSeatsByShowIdFailed,
    getAvailableSeatsFailed,
    updateSeatStatusFailed,
    bookSeatFailed,
} from "../reducers/seatSlice";
import { axiosInstance } from "../../config/axios";
import { apiEndpoints } from "../../utils/api-endpoints";
import { createErrorAction } from "../reducers/errorSlice";
import { getErrorMessage } from "../../utils/helper.utils";
function* getSeats(): any {
    try {
        const response = yield axiosInstance.get(apiEndpoints.seat.list);
        yield put(getSeatsSuccess(response.data));
    } catch (error) {
        yield put(getSeatsFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'seat/getSeats'));
    }
}

function* getSeatById(action: any): any {
    try {
        const response = yield axiosInstance.get(apiEndpoints.seat.byId(action.payload));
        yield put(getSeatByIdSuccess(response.data));
    } catch (error) {
        yield put(getSeatByIdFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'seat/getSeatById'));
    }
}

function* getSeatsByShowId(action: any): any {
    try {
        const response = yield axiosInstance.get(apiEndpoints.seat.byShowId(action.payload));
        yield put(getSeatsByShowIdSuccess(response.data));
    } catch (error) {
        yield put(getSeatsByShowIdFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'seat/getSeatsByShowId'));
    }
}

function* getAvailableSeats(action: any): any {
    try {
        const response = yield axiosInstance.get(apiEndpoints.seat.availableByShowId(action.payload));
        yield put(getAvailableSeatsSuccess(response.data));
    } catch (error) {
        yield put(getAvailableSeatsFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'seat/getAvailableSeats'));
    }
}

function* updateSeatStatus(action: any): any {
    try {
        const { id, status } = action.payload;
        const response = yield axiosInstance.put(apiEndpoints.seat.updateStatus(id), { status });
        yield put(updateSeatStatusSuccess(response.data));
    } catch (error) {
        yield put(updateSeatStatusFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'seat/updateSeatStatus'));
    }
}

function* bookSeat(action: any): any {
    try {
        const response = yield axiosInstance.put(apiEndpoints.seat.book(action.payload));
        yield put(bookSeatSuccess(response.data));
    } catch (error) {
        yield put(bookSeatFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'seat/bookSeat'));
    }
}

export function* watchSeatSaga() {
    yield takeLatest('seat/getSeats', getSeats);
    yield takeLatest('seat/getSeatById', getSeatById);
    yield takeLatest('seat/getSeatsByShowId', getSeatsByShowId);
    yield takeLatest('seat/getAvailableSeats', getAvailableSeats);
    yield takeLatest('seat/updateSeatStatus', updateSeatStatus);
    yield takeLatest('seat/bookSeat', bookSeat);
} 